import { CourseAttendanceRecord } from "@/core/endpoints/domain/courseAttendance_record";
import { BaseResponse } from "./_base_response";

export class CourseAttendanceResponse extends BaseResponse<CourseAttendanceRecord> {
  createRecord(): CourseAttendanceRecord {
    return new CourseAttendanceRecord();
  }
}
